import type { FunctionComponent } from 'react';

import IconCheckmark from 'assets/images/ai/icon-checkmark-white.svg';

import './style.scss';

export const IconActive: FunctionComponent = () => (
  <div styleName="container">
    <IconCheckmark />
  </div>
);
